export default function SectionHeading({ eyebrow, title, description, align = "left", light = false }) {
  const alignClass = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignClass}`}>
      {eyebrow && (
        <div className={`eyebrow ${light ? "text-red-400" : ""}`}>{eyebrow}</div>
      )}
      <h2
        className={`mt-3 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl ${
          light ? "text-white" : "text-slate-900"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p
          className={`mt-5 text-base sm:text-lg leading-relaxed ${
            light ? "text-slate-300" : "text-slate-600"
          }`}
        >
          {description}
        </p>
      )}
    </div>
  );
}
